var isTreeDropNodeValid = function isTreeDropNodeValid(_ref) {
  var canDrop = _ref.canDrop,
      source = _ref.source,
      target = _ref.target;
  return source.context.id !== target.context.id && source.context.parentId !== target.context.id && !target.context.ancestorIds.includes(source.context.id) && canDrop(target);
};

export { isTreeDropNodeValid };
